"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN_ID_TO_NETWORK_NAME = exports.NETWORK_NAME_TO_CHAIN_ID = exports.NetworkNames = void 0;
var NetworkNames;
(function (NetworkNames) {
    NetworkNames["Mainnet"] = "mainnet";
    NetworkNames["Ropsten"] = "ropsten";
    NetworkNames["Rinkeby"] = "rinkeby";
    NetworkNames["Goerli"] = "goerli";
    NetworkNames["Kovan"] = "kovan";
    NetworkNames["Xdai"] = "xdai";
    NetworkNames["Sokol"] = "sokol";
    NetworkNames["Bsc"] = "bsc";
    NetworkNames["BscTest"] = "bscTest";
    NetworkNames["Fantom"] = "fantom";
    NetworkNames["FantomTest"] = "fantomTest";
    NetworkNames["Matic"] = "matic";
    NetworkNames["Mumbai"] = "mumbai";
    NetworkNames["Aurora"] = "aurora";
    NetworkNames["AuroraTest"] = "auroraTest";
    NetworkNames["Avalanche"] = "avalanche";
    NetworkNames["Fuji"] = "fuji";
    NetworkNames["Etherspot"] = "etherspot";
    NetworkNames["LocalA"] = "localA";
    NetworkNames["LocalB"] = "localB";
    NetworkNames["LocalH"] = "localH";
})(NetworkNames = exports.NetworkNames || (exports.NetworkNames = {}));
exports.NETWORK_NAME_TO_CHAIN_ID = {
    [NetworkNames.Mainnet]: 1,
    [NetworkNames.Ropsten]: 3,
    [NetworkNames.Rinkeby]: 4,
    [NetworkNames.Goerli]: 5,
    [NetworkNames.Kovan]: 42,
    [NetworkNames.Xdai]: 100,
    [NetworkNames.Sokol]: 77,
    [NetworkNames.Bsc]: 56,
    [NetworkNames.BscTest]: 97,
    [NetworkNames.Fantom]: 250,
    [NetworkNames.FantomTest]: 4002,
    [NetworkNames.Matic]: 137,
    [NetworkNames.Mumbai]: 80001,
    [NetworkNames.Aurora]: 1313161554,
    [NetworkNames.AuroraTest]: 1313161555,
    [NetworkNames.Avalanche]: 43114,
    [NetworkNames.Fuji]: 43113,
    [NetworkNames.Etherspot]: 4386,
    [NetworkNames.LocalA]: 9999,
    [NetworkNames.LocalB]: 6666,
    [NetworkNames.LocalH]: 3333,
};
exports.CHAIN_ID_TO_NETWORK_NAME = Object.entries(exports.NETWORK_NAME_TO_CHAIN_ID).reduce((result, [networkName, chainId]) => (Object.assign(Object.assign({}, result), { [chainId]: networkName })), {});
